import React from "react";
import PropTypes from "prop-types";
import { AlertCircleFilled } from '@sainsburys-tech/icons'

const ErrorMessage = props => {
  const error = {
    title: "Oops! Something's gone wrong.",
    description: "Please try again later."
  };

  if (props.description) {
    error.title = "Error";
    error.description = props.description;
  }

  return (
    <React.Fragment>
      <AlertCircleFilled className="cb-c-error-message__error-icon" />
      <b>{error.title}</b>
      <p className="fable:mt-4">{error.description}</p>
    </React.Fragment>
  );
};

ErrorMessage.propTypes = {
  description: PropTypes.string
};

export default ErrorMessage;
